import Base from './Base';
import moment from 'moment';
import { useRecurringBroadcastsStore } from 'store/modules';

export default class RecurringBroadcast extends Base {
    constructor(item) {
        super(item);

        this.toggle = item.toggle !== this.toggle ? item.toggle : this.toggle;
        this.items = Array.isArray(item.items) ? item.items : [];
        this.pagination = item.pagination || null;
        this.params = item.params || {
            page: 1,
        };
        this.loading = item.loading || false;
        this.type = 'recurring';
    }

    get disabledButton() {
        return this.loading || (this.pagination && this.pagination.last_page);
    }

    get settingsType() {
        if (!this.settings) return '';

        return this.settings.type;
    }

    get settingsStatus() {
        if (!this.settings) return '';

        return this.settings.status;
    }

    get isTypeCustom() {
        return this.settingsType === 'custom';
    }

    get labelType() {
        if (this.settingsType === 'custom') return 'Custom';
        if (this.settingsType === 'daily') return 'Daily';
        if (this.settingsType === 'weekly') return 'Weekly';
        if (this.settingsType === 'monthly') return 'Monthly';

        return '';
    }

    get recurringTooltipText() {
        const recurring = this.settings;

        if (!recurring) return '';

        const type = recurring.send_settings.type;
        const interval = +recurring.send_settings.interval;
        const viewDaysFormatted = recurring.send_settings.schedule.days.map((item) =>
            moment(item, 'dddd').format('ddd')
        );
        const recurringDatesFormatted = recurring.send_settings.recurring_dates.map((item) =>
            moment().date(item).format('Do')
        );

        if (type === 'daily') {
            if (interval === 1) {
                return 'day';
            }

            return `${interval} days`;
        }

        if (type === 'weekly') {
            if (interval === 1) {
                return `week on ${viewDaysFormatted}`;
            }

            return `${interval} weeks on ${viewDaysFormatted}`;
        }

        if (type === 'monthly') {
            if (interval === 1) {
                return `month on ${recurringDatesFormatted}`;
            }

            return `${interval} months on ${recurringDatesFormatted}`;
        }

        return '';
    }

    get statusClass() {
        if (this.isStatusFinished) {
            return 'has-background-success';
        }

        if (this.isStatusActive) {
            return 'has-background-orange';
        }

        if (this.isStatusInactive) {
            return 'has-background-grey';
        }

        return '';
    }

    get statusFormatted() {
        if (this.isStatusFinished) {
            return 'Finished';
        }

        if (this.isStatusActive) {
            return 'Active';
        }

        if (this.isStatusInactive) {
            return 'Inactive';
        }

        return this.settingsStatus;
    }

    get isStatusFinished() {
        return this.settingsStatus === 'finished';
    }

    get isStatusActive() {
        return this.settingsStatus === 'active';
    }

    get isStatusInactive() {
        return this.settingsStatus === 'inactive';
    }

    get isResume() {
        return this.isStatusInactive;
    }

    get isStop() {
        return this.isStatusInactive || this.isStatusActive;
    }

    get isPause() {
        return this.isStatusActive;
    }

    get isRename() {
        return this.isStatusInactive || this.isStatusActive || this.isStatusFinished;
    }

    get isClone() {
        return this.isStatusInactive || this.isStatusActive || this.isStatusFinished;
    }

    get isViewReport() {
        return this.isStatusFinished;
    }

    get isDelete() {
        return this.isStatusFinished;
    }

    get data() {
        return {
            id: this.id,
            created_at: this.created_at,
            toggle: this.toggle,
            items: this.items,
            pagination: this.pagination,
            loading: this.loading,
            params: this.params,
            message: this.message,
            name: this.name,
            organization_id: this.organization_id,
            owner_id: this.owner_id,
            settings: this.settings,
            status: this.status,
            updated_at: this.updated_at,
            disabled: this.disabled,
        };
    }

    async handleToggle() {
        if (this.toggle) {
            await this.handleHide();
        } else {
            await this.handleShow();
        }
    }

    async handleShow() {
        if (this.toggle) return;

        await useRecurringBroadcastsStore().recurringBroadcastsStateUpdateItem({
            id: this.id,
            props: {
                toggle: true,
                items: [],
                pagination: null,
                params: {
                    page: 1,
                },
            },
        });
        await this.load();
    }

    async handleHide() {
        if (!this.toggle) return;

        await useRecurringBroadcastsStore().recurringBroadcastsStateUpdateItem({
            id: this.id,
            props: {
                toggle: false,
                items: [],
                pagination: null,
                params: {
                    page: 1,
                },
            },
        });
    }

    async load() {
        await useRecurringBroadcastsStore().recurringBroadcastsItemsLoad({
            item: this,
        });
    }

    async reUpdate() {
        if (this.toggle) {
            await useRecurringBroadcastsStore().recurringBroadcastsStateUpdateItem({
                id: this.id,
                props: {
                    items: [],
                    pagination: null,
                    params: {
                        page: 1,
                    },
                },
            });
        }
    }

    async handleAction(status) {
        await useRecurringBroadcastsStore().updateBroadcastsRecurringByIdByStatus({
            item: this,
            status: status,
        });
    }
}
